export default async (locale) => {
  await import('moment-timezone').then(moment => {
    moment.locale(locale);
  });
};
